import { getUrlWithId, useGetFetch } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';
import { FetchRemindersResponseType } from '../reminders/useSearchReminders';

export const useGetProjectReminders = (id: string) =>
  useGetFetch<FetchRemindersResponseType>({
    url: getUrlWithId(ApiRoutesEnum.getProject, id).concat('/reminders'),
    config: { enabled: !!id },
  });
